export default function Calculator({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44771 20 6 19.5523 6 19V5ZM8 6H16V9H8V6ZM8 10H10V12H8V10ZM13 10H11V12H13V10ZM14 10H16V12H14V10ZM10 13H8V15H10V13ZM11 13H13V15H11V13ZM16 13H14V15H16V13ZM8 16H10V18H8V16ZM13 16H11V18H13V16ZM14 16H16V18H14V16Z"
        fill="currentColor"
      />
    </svg>
  )
}
